import React from "react";

import { useField } from "formik";
import { Form, Label } from "semantic-ui-react";
import { inputStepper } from "constants/formConstants";

function RateInput({ currency = "Rs.", forSale = false, ...rest }) {
	const [
		{ value: rate },
		{ error: rateValidationError, touched },
		{ setValue: setRate },
	] = useField("rate");
	return (
		<>
			<Form.Input
				{...rest}
				fluid
				name="rate"
				placeholder={`Rate of ${forSale ? "sale" : "purchase"}`}
				label="Rate"
				value={rate}
				onChange={(e) => setRate(e.target.value, true)}
				type="number"
				labelPosition="left"
				step={inputStepper}
				min={0}
			>
				<Label content={currency}></Label>
				<input />
			</Form.Input>

			<p style={{ color: "red" }}>
				{rateValidationError && touched && rateValidationError}
			</p>
		</>
	);
}

export default RateInput;
